// @flow

// eslint-disable-next-line import/prefer-default-export
import astro from '../Icons/Images/astro_w.svg';
import dove from '../Icons/Images/dove_w.svg';
import home from '../Icons/Images/home_w.svg';
import profile from '../Icons/Images/profile_w.svg';
import rocket from '../Icons/Images/rocket_w.svg';
import surf from '../Icons/Images/surf_w.svg';
import tree from '../Icons/Images/tree_w.svg';

export const HOME_SCREEN = 'home';
export const LOGIN_SCREEN = 'login';
export const CREATE_PROFILE_SCREEN = 'profile/add';
export const CREATE_DEVICE_SCREEN = 'device/add';
export const EDIT_PROFILE_SCREEN = 'profile/edit';
export const EDIT_DEVICE_SCREEN = 'device/edit';
export const AUTO_LOGIN_COMPLETE_SCREEN = 'autologin/complete';

export const TRIAL_PERIOD_START = 'trial/start';
export const TRIAL_PERIOD_QUEUE = 'trial/queue';
export const TRIAL_PERIOD_ACTIVATE = 'trial/activate';

export const MYCOOOLBOX_URL = 'https://my.cooolbox.bg/';
export const MYCOOOLBOX_GENERAL_TERMS_URL = 'https://www.cooolbox.bg/files/obshti-uslovia-coool-tv.pdf';
export const MYCOOOLBOX_PRIVACY_URL = 'https://www.cooolbox.bg/files/Privacy-policy-coool.tv.pdf';
export const MANUAL_COOKIES_URL = `https://${window.location.hostname}/help#manual`;
export const COOOLTV_TV_PROGRAMS = `https://${window.location.hostname}/#packages`;
export const COOOLTV_SUPPORTED_DEVICES = `https://${window.location.hostname}/#devices`;
export const COOOLTV_FAQ = `https://${window.location.hostname}/#faq`;

export const CATEGORY_NOMENCLATURE_TYPE_CODE = 'tv_channel_category';
export const RESOLUTION_NOMENCLATURE_TYPE_CODE = 'tv_channel_resolution';

export const PROFILE_IMAGES = [
    { name: 'astro', path: astro },
    { name: 'dove', path: dove },
    { name: 'profile', path: profile },
    { name: 'home', path: home },
    { name: 'rocket', path: rocket },
    { name: 'surf', path: surf },
    { name: 'tree', path: tree },
];
